import "core-js/modules/es.array.push.js";
import UploadForm from '@/components/UploadForm.vue';
import Footer from '@/components/Footer.vue';
import { ref } from 'vue';
import cookies from 'vue-cookies';
import { mapGetters } from 'vuex';
export default {
  name: 'UploadHome',
  data() {
    return {
      selectedUrlForm: ref(''),
      showUrlDialog: false,
      bingWallPaperIndex: 0,
      customWallPaperIndex: 0,
      showCompressDialog: false,
      customerCompress: true,
      //上傳前壓缩
      compressQuality: 4,
      //壓缩后大小
      compressBar: 5,
      //壓缩阈值
      serverCompress: true,
      //服務器端壓缩
      uploadChannel: 'telegram' //上傳渠道
    };
  },
  watch: {
    customerCompress(val) {
      this.updateCompressConfig('customerCompress', val);
    },
    compressQuality(val) {
      this.updateCompressConfig('compressQuality', val);
    },
    compressBar(val) {
      this.updateCompressConfig('compressBar', val);
    },
    serverCompress(val) {
      this.updateCompressConfig('serverCompress', val);
    },
    uploadChannel(val) {
      this.updateStoreUploadChannel(val);
    }
  },
  computed: {
    ...mapGetters(['userConfig', 'bingWallPapers', 'uploadCopyUrlForm', 'compressConfig', 'storeUploadChannel']),
    ownerName() {
      return this.userConfig?.ownerName || 'DreamersAudio;
    },
    logoUrl() {
      return this.userConfig?.logoUrl || require('../assets/logo.png');
    },
    bkInterval() {
      return this.userConfig?.bkInterval || 3000;
    },
    bkOpacity() {
      return this.userConfig?.bkOpacity || 1;
    },
    dialogWidth() {
      return window.innerWidth > 768 ? '40%' : '80%';
    },
    disableTooltip() {
      return window.innerWidth < 768;
    }
  },
  mounted() {
    const bg1 = document.getElementById('bg1');
    const bg2 = document.getElementById('bg2');
    if (this.userConfig?.uploadBkImg === 'bing') {
      //bing壁纸轮播
      this.$store.dispatch('fetchBingWallPapers').then(() => {
        bg1.src = this.bingWallPapers[this.bingWallPaperIndex]?.url;
        bg1.onload = () => {
          bg1.style.opacity = this.bkOpacity;
        };
        setInterval(() => {
          //如果bing壁纸组為空，跳過
          let curBg = bg1.style.opacity != 0 ? bg1 : bg2;
          let nextBg = bg1.style.opacity != 0 ? bg2 : bg1;
          curBg.style.opacity = 0;
          this.bingWallPaperIndex = (this.bingWallPaperIndex + 1) % this.bingWallPapers.length;
          nextBg.src = this.bingWallPapers[this.bingWallPaperIndex]?.url;
          nextBg.onload = () => {
            nextBg.style.opacity = this.bkOpacity;
          };
        }, this.bkInterval);
      });
    } else if (this.userConfig?.uploadBkImg instanceof Array && this.userConfig?.uploadBkImg?.length > 1) {
      //自定义壁纸组轮播
      bg1.src = this.userConfig.uploadBkImg[this.customWallPaperIndex];
      bg1.onload = () => {
        bg1.style.opacity = this.bkOpacity;
      };
      setInterval(() => {
        let curBg = bg1.style.opacity != 0 ? bg1 : bg2;
        let nextBg = bg1.style.opacity != 0 ? bg2 : bg1;
        curBg.style.opacity = 0;
        this.customWallPaperIndex = (this.customWallPaperIndex + 1) % this.userConfig.uploadBkImg.length;
        nextBg.src = this.userConfig.uploadBkImg[this.customWallPaperIndex];
        nextBg.onload = () => {
          nextBg.style.opacity = this.bkOpacity;
        };
      }, this.bkInterval);
    } else if (this.userConfig?.uploadBkImg instanceof Array && this.userConfig?.uploadBkImg.length == 1) {
      //單张自定义壁纸
      bg1.src = this.userConfig.uploadBkImg[0];
      bg1.onload = () => {
        bg1.style.opacity = this.bkOpacity;
      };
    } else {
      //默认壁纸
      bg1.src = require('@/assets/background.jpg');
      bg1.onload = () => {
        bg1.style.opacity = this.bkOpacity;
      };
    }
    // 读取用户選擇的連接格式
    this.selectedUrlForm = this.uploadCopyUrlForm || 'url';
    // 读取用户選擇的壓缩設置
    this.customerCompress = this.compressConfig.customerCompress;
    this.compressQuality = this.compressConfig.compressQuality;
    this.compressBar = this.compressConfig.compressBar;
    this.serverCompress = this.compressConfig.serverCompress;
    // 读取用户選擇的上傳渠道
    this.uploadChannel = this.storeUploadChannel;
  },
  components: {
    UploadForm,
    Footer
  },
  methods: {
    handleManage() {
      this.$router.push('/dashboard');
    },
    openUrlDialog() {
      this.showUrlDialog = true;
    },
    handleLogout() {
      cookies.remove('authCode');
      this.$router.push('/login');
      this.$message.success('已退出登錄');
    },
    changeUrlForm() {
      this.$store.commit('setUploadCopyUrlForm', this.selectedUrlForm);
    },
    openCompressDialog() {
      this.showCompressDialog = true;
    },
    updateCompressConfig(key, value) {
      this.$store.commit('setCompressConfig', {
        key,
        value
      });
    },
    updateStoreUploadChannel(value) {
      this.$store.commit('setStoreUploadChannel', value);
    }
  }
};